import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PathService } from "../../login/services/path.service";
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigAssetLoaderService {

    constructor(private http: HttpClient, private pathService: PathService) {
    }

    public loadConfigurations() {
        this.pathService.hostServerBackOffice = environment.hostServerBackOffice;
        this.pathService.hostServerSecurity = environment.hostServerSecurity;
    }

}